import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toggleAutomation } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { DmAutomationDto } from '@/types/dmAutomation';

interface Variables {
    id: string;
    isActive: boolean;
}

interface Context {
    previous?: DmAutomationDto[];
}

export const useToggleAutomation = () => {
    const queryClient = useQueryClient();
    return useMutation<void, unknown, Variables, Context>({
        mutationFn: ({ id, isActive }) => toggleAutomation(id, isActive),
        onMutate: async ({ id, isActive }) => {
            const listKey = queryKeys.dmAutomation.list();
            await queryClient.cancelQueries({ queryKey: listKey });
            const previous = queryClient.getQueryData<DmAutomationDto[]>(listKey);
            if (previous) {
                queryClient.setQueryData<DmAutomationDto[]>(
                    listKey,
                    previous.map((item) => (item.id === id ? { ...item, isActive } : item)),
                );
            }
            return { previous };
        },
        onError: (_err, _vars, context) => {
            if (context?.previous) {
                queryClient.setQueryData(queryKeys.dmAutomation.list(), context.previous);
            }
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.dmAutomation.list() });
        },
    });
};
